import { connect } from "react-redux";

var Owlvatar = require("components/avatars/Owlvatar");
var CurrentUser = require("lib/account/CurrentUser");
var AnimateOwl = require("lib/games/AnimateOwl")

var RosterSelectors = require("lib/selectors/RosterSelectors");

@connect(
	(state, props) => {

		// Make this component able to be provided data by IDs or objects
		// For backwards compatability with non-redux pages

		var student = props.student;
		if (!student) {
			if (props.studentID) {
				student = RosterSelectors.student({ state, id: props.studentID })
			}
		}

		var avatar = props.avatar;
		if (!avatar) {
			if (props.avatarID) {
				avatar = RosterSelectors.avatar({ state, id: props.avatarID })
			} else if (student && _.isObject(student.avatar)) {
				avatar = student.avatar;
			} else if (student) {
				avatar = RosterSelectors.avatarForStudent({
					state, studentID: student.id
				});
			}
		}

		return { student, avatar };
	},

	(dispatch, props) => ({})
)
class StudentAvatar extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	getConstraints(maxWidth, maxHeight) {
		var constraints = {};
		if (maxWidth) { constraints.width = (maxWidth + "px") };
		if (maxHeight) { constraints.height = (maxHeight + "px") };
		return constraints;
	}

	render() {		
		var student = this.props.student;
		var avatar = this.props.avatar;
		if (!avatar && _.isObject(student.avatar)) {
			avatar = student.avatar;
		}
		var currentUser = CurrentUser.get();

		if (currentUser && currentUser.settings && currentUser.settings.hide_owls) {
			var constraints = this.getConstraints(this.props.maxWidth, this.props.maxHeight)
			var src = require("misc/monkey.png");
			return (
				<img src={ src } className="owlvatarStandin" style={ constraints } />
			);

		} else if (avatar.is_monster) {
			var constraints = this.getConstraints(this.props.maxWidth, this.props.maxHeight);
			var imagePath = require("monsters/monster-" + avatar.transform_type + ".png");
			return (
				<img src={ imagePath } className="owlvatarStandin" style={ constraints } />
			);

		} else {
			if (this.props.student.settings && this.props.student.settings.took_honor_pledge) {
				var showHonorRays = true;
			}
			return (
				<span ref="avatar" className="studentOwlvatar">
					<Owlvatar maxWidth={ this.props.maxWidth } maxHeight={ this.props.maxHeight }
						patches={ avatar.patches } colors={ avatar.colors }
						nofloat={ this.props.nofloat }
						showHonorRays={ showHonorRays } />
				</span>
			);
		}
	}
	getIdentifier() {
		if (this.props.location) {
			return this.props.student.username + "_" + this.props.location
		} else {
			return this.props.student.username
		}
	}
	componentDidMount() {
		if (this.refs.avatar && this.props.student && this.props.student.perks) {
			if (this.props.disableSound == undefined || !this.props.disableSound) {
				if (window.wrL2eSound) {
					window.wrL2eSound.buildStudentSources(this.getIdentifier(),this.props.student.perks)					
				}
			}
			if (!this.props.disableAnimation) {
				setTimeout(function(){
					if (this.props.previewAnimation) {
						this.triggerPreviewAnimation()
					} else {
						this.triggerOwlAnimation()
					}
				}.bind(this),500)
			}
		}
	}

	// previews animation (for owl shop)
	triggerPreviewAnimation() {
		var avatar = this.props.avatar || this.props.student.avatar;

		AnimateOwl.alive_owl( $(this.refs.avatar).find(".owlConstraintsInner"),2000,this.getIdentifier(),avatar.patches,this.props.student.perks,this.props.previewAnimation)	
	}

	triggerOwlAnimation() {
		var avatar = this.props.avatar || this.props.student.avatar;
		if (!$(this.refs.avatar).find(".owlConstraintsInner").length) {
			setTimeout(function(){
				this.triggerOwlAnimation()
			}.bind(this),1000)
		} else {
			AnimateOwl.alive_owl( $(this.refs.avatar).find(".owlConstraintsInner"),2000,this.getIdentifier(),avatar.patches,this.props.student.perks,false)	
		}
	}
	componentWillUnmount() {
		if (window.wrL2eSound) {
			window.wrL2eSound.removeSources(this.getIdentifier())			
		}
		if (this.refs.avatar) {
			AnimateOwl.stop_animation($(this.refs.avatar).find(".owlConstraintsInner"),this.getIdentifier())
		}
	}
};

StudentAvatar.WrappedComponent.propTypes = StrictPropTypes({
	// Avatar+Student can be directly provided or via ID or just by student
	student: PropTypes.object,
	avatar: PropTypes.object,

	studentID: PropTypes.number,
	avatarID: PropTypes.number,
	nofloat: PropTypes.bool, // Too many legacy uses depend on it floating

	disableAnimation: PropTypes.bool,
	disableSound: PropTypes.bool,
	location: PropTypes.string,
	maxWidth: PropTypes.number,
	maxHeight: PropTypes.number,
	previewAnimation: PropTypes.string,
});

module.exports = StudentAvatar;


// WEBPACK FOOTER //
// ./modules/components/avatars/StudentAvatar.js